import React from 'react';

import Section from '../components/section';

export default ({ title, description, children }) => (
  <Section title={title} description={description}>
    {children}
  </Section>
);



// WEBPACK FOOTER //
// ./src/fitbit-components/section.js